import React from 'react';
import PropTypes from 'prop-types';

const Loading = ({loaderCount, loadingWrapClass}) => {
  const loaderDots = [...Array(loaderCount).keys()].map(item => <span key={item} />);

  return (
    <div className={`loading-wrap ${loadingWrapClass}`}>
      <div className="loading loading--active">
        {loaderDots}
      </div>
    </div>
  );
};

Loading.defaultProps = {
  loaderCount: 5,
};

Loading.PropTypes = {
  loaderCount:PropTypes.number,
  loadingWrapClass:PropTypes.string.isRequired,
};

export default Loading;
